import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Link, useLocation } from "react-router-dom";
import SearchPage from "./pages/SearchPage.jsx";
import LoginPage from "./pages/LoginPage.jsx";
import RegisterPage from "./pages/RegisterPage.jsx";
import AccountPage from "./pages/AccountPage.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import PrivacyPolicy from "./pages/PrivacyPolicy.jsx";
import TermsPage from "./pages/TermsPage.jsx";
import { AuthProvider, useAuth } from "./AuthContext.jsx";

/* ---------- Header (updated, but providers remain below in App) ---------- */
function Header() {
  const { user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  // Close menu when route changes
  useEffect(() => setMenuOpen(false), [location.pathname]);

  // Close menu if resized to desktop
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 700) setMenuOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <header
      className="app-header"
      data-menu-open={menuOpen ? "true" : "false"}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "relative",
      }}
    >
      <div
        className="brand"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <img
          src="/logo512.png"
          alt="Gluten Free Navigator Logo"
          style={{ width: 36, height: 36, borderRadius: "8px" }}
        />
        <h1 className="site-title" style={{ margin: 0 }}>
          Gluten Free Navigator - San Francisco Bay Area
        </h1>
      </div>

      {/* Mobile hamburger (hidden on desktop via CSS) */}
      <button
        className="nav-toggle"
        aria-label="Toggle navigation"
        aria-expanded={menuOpen}
        aria-controls="site-nav"
        onClick={() => setMenuOpen((v) => !v)}
      >
        <span className="hamburger" aria-hidden="true"></span>
      </button>

      {/* Nav (inline on desktop; popover on mobile via CSS) */}
      <nav id="site-nav" className="site-nav">
        <Link to="/">Search</Link>
        {user ? (
          <>
            <Link to="/account">Account</Link>
            <button onClick={logout} style={{ cursor: "pointer" }}>Logout</button>
          </>
        ) : (
          <>
            <Link to="/login">Log in</Link>
            <Link to="/register">Register</Link>
          </>
        )}
      </nav>
    </header>
  );
}

/* ------------------------------ App (unchanged structure) ------------------------------ */
export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="app-shell">
          <Header />
          <main className="app-main">
            <Routes>
              <Route path="/" element={<SearchPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route
                path="/account"
                element={
                  <ProtectedRoute>
                    <AccountPage />
                  </ProtectedRoute>
                }
              />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsPage />} />
            </Routes>
          </main>
          <footer className="app-footer">
            Copyright by Gluten Free Navigator. 
            Always confirm directly with restaurants before eating. 
            <div style={{ marginTop: 6 }}>
            <Link to="/privacy">Privacy Policy</Link> · <Link to="/terms">Terms & Conditions</Link>
          </div>
          </footer>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}
